var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 59,
    viewBox: "0 0 45 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0898 58.5L4.42903 35.8584L4.40912 35.8336C1.52487 31.9904 0 27.4105 0 22.5898C0 10.4099 9.9099 0.5 22.0898 0.5C34.2698 0.5 44.1797 10.4099 44.1797 22.5898C44.1797 27.4105 42.6548 31.9904 39.7507 35.8584L22.0898 58.5Z",
    fill: "#FFFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.7686L20.3032 30.0717L32.5719 17.8031",
    stroke: "url(#paint0_linear)",
    strokeWidth: 4.77537
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.2863,
    y1: 33.0886,
    x2: 34.2479,
    y2: 16.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.1a3bfe309a04f5dad7e0c4ea72b6ec2a.svg";
export { ForwardRef as ReactComponent };